<script>
import { getValue, MARKET_TYPE } from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { getCarbonList, updateCarbon, getSupportCurrency } from "@/api/carbon";

export default {
  computed: {
    MARKET_TYPE() {
      return MARKET_TYPE;
    },
    formatApiDate() {
      return formatApiDate;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        type: "",
        code: "",
        page: 1,
        limit: 20
      },
      dialogFormVisible: false, // 新增 or 编辑的弹框
      rules: {
        currency: [
          { required: true, message: "币种不能为空", trigger: "change" }
        ],
        curPrice: [
          { required: true, message: "当前价格不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        currency: "", // 币种
        curPrice: "", // 当前价格
        startPrice: "", // 开盘价格
        minPrice: "", // 最低价格
        maxPrice: "", // 最高价格
        endPrice: "", // 昨日收盘价格
        totalAmount: "", // 成交金额
        totalTon: "" // 成交数量
      },
      btnLoading: false,
      supportOption: [] // 币种
    };
  },
  created() {
    this.getList();
    this.getSupportCurrency();
  },
  watch: {},
  mounted() {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getCarbonList(this.listQuery)
        .then(response => {
          this.list = (response.data && response.data.data) || [];
          this.total = response.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 切换状态
     * @param status
     * @param editObj
     */
    checkDialogFormVisible(status, editObj = {}) {
      if (editObj && Object.keys(editObj).length !== 0) {
        this.form.id = editObj.id;
        this.form.currency = editObj.currency;
        this.form.curPrice = editObj.cur_price;
        this.form.startPrice = editObj.start_price;
        this.form.minPrice = editObj.min_price;
        this.form.maxPrice = editObj.max_price;
        this.form.endPrice = editObj.end_price;
        this.form.totalAmount = editObj.total_amount;
        this.form.totalTon = editObj.total_ton;
      }
      this.dialogFormVisible = status;
      if (!status) {
        this.form.id = 0;
        this.$refs.form.resetFields();
      }
    },
    getSupportCurrency() {
      getSupportCurrency().then(resp => {
        console.log("resp", resp);
        const supportOption = [];
        if (resp && resp.code === 0) {
          const data = resp.data;
          data.map(item => {
            supportOption.push({
              key: item,
              value: item
            });
          });
        }
        this.supportOption = supportOption;
      });
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = this.form;
          this.btnLoading = true;
          updateCarbon(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in MARKET_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-input
        v-model="listQuery.code"
        placeholder="代码"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="id" label="编号" width="80"> </el-table-column>
      <el-table-column prop="name" label="名称" width="120"></el-table-column>
      <el-table-column prop="code" label="代码" width="120"></el-table-column>
      <el-table-column prop="currency" label="币种"></el-table-column>
      <el-table-column prop="cur_price" label="当前价格" width="120">
      </el-table-column>
      <el-table-column prop="end_price" label="昨日收盘价格" width="120">
      </el-table-column>
      <el-table-column prop="float_price" label="涨幅"></el-table-column>
      <el-table-column
        prop="float_rate"
        label="涨幅率"
        width="100"
      ></el-table-column>
      <el-table-column prop="max_price" label="最高价格"></el-table-column>
      <el-table-column prop="min_price" label="最低价格"></el-table-column>
      <el-table-column prop="start_price" label="开盘价格"></el-table-column>
      <el-table-column prop="total_amount" label="成交金额"></el-table-column>
      <el-table-column prop="total_ton" label="成交数量"></el-table-column>
      <el-table-column prop="type" label="市场类型" width="100">
        <template slot-scope="scope">
          {{ getValue(MARKET_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.created_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="修改时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row)"
            style="margin-right: 8px"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="修改"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="checkDialogFormVisible(false, {})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="币种" prop="currency">
          <el-select
            v-model="form.currency"
            placeholder="请选择"
            style="width: 200px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in supportOption"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="当前价格" prop="curPrice">
          <el-input v-model="form.curPrice" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="开盘价格" prop="startPrice">
          <el-input v-model="form.startPrice" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="最低价格" prop="minPrice">
          <el-input v-model="form.minPrice" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="最高价格" prop="maxPrice">
          <el-input v-model="form.maxPrice" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="昨日收盘价格" prop="endPrice">
          <el-input v-model="form.endPrice" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="成交金额" prop="totalAmount">
          <el-input v-model="form.totalAmount" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="成交数量" prop="totalTon">
          <el-input v-model="form.totalTon" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
